import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

function FormH3Preview({ ...props }) {
  const { field: { label } } = useFormFieldContext()

  return <BasePreview {...props}>
    <h3>{label}</h3>
  </BasePreview>
}

export default define('form-heading-h3', FormH3Preview, Fragment)
  .shared(prop.share('FormH3', 'form-heading-h3'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

